import Vue from 'vue';
import Router from 'vue-router';
import Common from './common';
import Solution from './solution';
import Account from './account';
import Coin from './coin';
import purchase from './purchase';
import library from './library';
// import pub from './pub';
// import goTo from 'vuetify/lib/services/goto'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: '/user',
    // scrollBehavior: (to, from, savedPosition) => {
    //     let scrollTo = 0
    //     if (to.hash) {
    //         scrollTo = to.hash
    //     } else if (savedPosition) {
    //         scrollTo = savedPosition.y
    //     }
    //     return goTo(scrollTo)
    // },
    scrollBehavior (to, from, savedPosition) {
        console.log(savedPosition)
        if (to.path !== from.path) {
            window.document.getElementById('app').scrollTop = 0
            return { x: 0, y: 0 }
        }
    },
    routes: [
        // ...pub,
        ...Common,
        ...Solution,
        ...Account,
        ...Coin,
        ...purchase,
        ...library,
        // {
        //     path: '/user/error/:type',
        //     name: '에러',
        //     component: () => import('@/page/error/ErrorIndex.vue'),
        // },
        {
            path: '/cert-test-page',
            name: 'CertTest',
            component: () => import(`@/page/CertTest.vue`),
        },
        {
            path: '/push-test-page',
            name: 'PushTest',
            component: () => import(`@/page/PushTest.vue`),
        },
        {
            path: '/404',
            name: 'NotFound',
            component: () => import(`@/page/error/NotFound.vue`),
            meta: {}
        },
        {
            path: '*',
            redirect: '/404'
        },
        {
            path: '/com-error',
            name: 'Internal',
            component: () => import(`@/page/error/Internal.vue`),
            meta: {}
        },
        {
            path: '/exp-error',
            name: 'Expired',
            component: () => import(`@/page/error/Expired.vue`),
            meta: {}
        },
        {
            path: 'fo/mission',
            name: '퍼블_미션',
            component: () => import('@/page/mission/MissionMain.vue'),
            children: [
                {
                    path: 'tutorial',
                    name: '퍼블_미션 튜토리얼',
                    component: () => import('@/components/mission/MissionTutorial.vue')
                }
            ]
        },
    ]
});

export default router;
